// extracted by mini-css-extract-plugin
export default {"uploadLogoContainer":"UploadLogo_uploadLogoContainer__Pfcrw","buttons":"UploadLogo_buttons__gc7bL","cropContainer":"UploadLogo_cropContainer__ZmfM2"};